import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { zh, en } from '@/plugins/lang';
import getLang from '@/utils/getLang';

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: getLang(),  //zh 中文    en 英文
  fallbackLocale: 'cn',
  messages: {
    'cn': {
     ...zh, 
    },
    'en': {
      ...en,
    }
  }
})

export default i18n;